module.exports = __webpack_public_path__ + "img/cr2.f5ccbd62.png";